import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=2b2666ef&scoped=true&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"
import style0 from "./editor.vue?vue&type=style&index=0&id=2b2666ef&prod&scoped=true&lang=scss&"
import style1 from "./editor.vue?vue&type=style&index=1&id=2b2666ef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2666ef",
  null
  
)

export default component.exports